import React from "react";
import Facebook from './icons/facebook';
import { useTranslation } from "../lib/i18n";

export default function Footer() {
  const { t } = useTranslation();

  const busList = [
    { label: "Autobusas", model: "SETRA 415 GT-HD" },
    { label: "Autobusas", model: "SETRA 415 HD" },
    { label: "Mikroautobusas", model: "Mercedes-Benz Sprinter" },
    { label: "Mikroautobusas", model: "Volkswagen Crafter" },
  ];

  return (
    <footer className="bg-[#1f1f1f] text-white mt-12">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <h2 className="text-red-400 uppercase tracking-wider border-t border-b border-red-400 pt-2 pb-4">{t("footerContacts")}</h2>
          <div className="mt-4 text-sm text-slate-300">
            <p className="font-semibold">{t("contactRegAddress")}</p>
            <p>V. Landsbergio-Žemkalnio 14-1, Kaunas</p>

            <p className="mt-4 font-semibold">{t("contactOfficeAddress")}</p>
            <p>Šiauriečių aklg. 17, Kaunas</p>

            <p className="mt-4">Tel. +370 698 82999;<br />+370 605 88874</p>

            <p className="mt-4">{t("contactCompanyCode")} 135938833<br />{t("contactVatCode")} LT359388314</p>

            <p className="mt-4">info@transrentus.lt<br />transrentus@transrentus.lt</p>
          </div>
        </div>

        <div>
          <h2 className="text-red-400 uppercase tracking-wider border-t border-b border-red-400 pt-2 pb-4">{t("footerBusHeading")}</h2>
          <div className="mt-4 text-slate-300 text-sm leading-relaxed">
            <p>{t("footerBusDesc")}</p>

            <ul className="mt-4 space-y-2">
              {busList.map((bus) => (
                <li key={bus.model}><span className="font-semibold">{bus.label}</span> <strong>{bus.model}</strong></li>
              ))}
            </ul>
          </div>
        </div>

        <div>
          <h2 className="text-red-400 uppercase tracking-wider border-t border-b border-red-400 pt-2 pb-4">{t("footerFollow")}</h2>
          <div className="mt-6">
            <div className="flex gap-3">
              <a href="#" aria-label="Transrentus on Facebook" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center text-slate-300 hover:text-white"><Facebook /></a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between text-sm text-slate-400">
          <div>© {(new Date().getFullYear() === 2026) ? new Date().getFullYear() : '2026-' + new Date().getFullYear()} UAB „Transrentus“</div>
          <div className="flex items-center gap-2">
            <div>{t("footerSolution")}</div>
            <div className="text-red-400 font-semibold">Titas Petrauskas</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
